<div class="cockpit-content">
  <h1>{{card.title | translate}}</h1>
  <div class="cockpit-view">
    <div class="table-wrapper">
      <app-chart-download-button (buttonClick)="exportChartTable()">
        <h5>{{ 'sprint9.cockpit.card.all.tabelle' | translate }}</h5>
      </app-chart-download-button>

      <div class="table-wrapper">
        <table>
          <tr>
            <th scope="col" colspan="1" class="no-border"></th>
            <th scope="colgroup" colspan="4" class="header border-bold-left border-bold-right bold centered">
              {{ 'i18n.cockpit.card.chart.gesamtverdienstLohn.durchschnittswerte' | translate }}</th>
            <th scope="colgroup" colspan="3" class="header border-bold-left border-bold-right bold centered">
              {{ 'i18n.cockpit.card.chart.gesamtverdienstLohn.anteilGesamtverdienst' | translate }}</th>
            <th scope="colgroup" colspan="3" class="header border-bold-left border-bold-right bold centered">
              {{ 'i18n.cockpit.card.chart.gesamtverdienstLohn.anteilPersonnenLohnbestandteileErhalten' | translate }}
            </th>
          </tr>

          <tr>
            <th scope="col" colspan="1" class="header border-bold-left border-bold-right bold centered">
              {{'i18n.cockpit.card.chart.gesamtverdienstLohn.lohnbestandteile' | translate }}
            </th>
            <th scope="col" class="centered">{{ 'i18n.common.maenner' | translate }}</th>
            <th scope="col" class="centered">{{ 'i18n.common.frauen' | translate }}</th>
            <th scope="col" class="centered">{{ 'i18n.cockpit.card.chart.gesamtverdienstLohn.diff_f_h' | translate }}</th>
            <th scope="col" class="centered border-bold-right">{{ 'i18n.common.gesamt' | translate }}</th>

            <th scope="col" class="centered">{{ 'i18n.common.maenner' | translate }}</th>
            <th scope="col" class="centered">{{ 'i18n.common.frauen' | translate }}</th>
            <th scope="col" class="centered border-bold-right">{{ 'i18n.common.gesamt' | translate  }}</th>

            <th scope="col" class="centered">{{ 'i18n.common.maenner' | translate }}</th>
            <th scope="col" class="centered">{{ 'i18n.common.frauen' | translate }}</th>
            <th scope="col" class="centered border-bold-right">{{ 'i18n.common.gesamt' | translate }}</th>
          </tr>

          <tr class="content">
            <th scope="row" colspan="1" class="border-bold-left border-bold-right">
              {{'i18n.cockpit.card.chart.gesamtverdienstLohn.grundlohn' | translate }}
            </th>
            <td>{{ gesamtverdienstUndLohnbestandteile.grundlohnMaennerDurchschnitt | numberFormat: crtLocale }}</td>
            <td>{{ gesamtverdienstUndLohnbestandteile.grundlohnFrauenDurchschnitt | numberFormat: crtLocale }}</td>
            <td>{{ gesamtverdienstUndLohnbestandteile.grundlohnDifferenz }}</td>
            <td class="border-bold-right">
              {{ gesamtverdienstUndLohnbestandteile.grundlohnMitarbeitendeDurchschnitt | numberFormat: crtLocale }}</td>

            <td>{{ gesamtverdienstUndLohnbestandteile.grundlohnMaennerAnteil }}</td>
            <td>{{ gesamtverdienstUndLohnbestandteile.grundlohnFrauenAnteil }}</td>
            <td class="border-bold-right">{{ gesamtverdienstUndLohnbestandteile.grundlohnMitarbeitendeAnteil }}</td>

            <td>{{ gesamtverdienstUndLohnbestandteile.grundlohnMaennerErhalten }}</td>
            <td>{{ gesamtverdienstUndLohnbestandteile.grundlohnFrauenErhalten }}</td>
            <td class="border-bold-right">{{ gesamtverdienstUndLohnbestandteile.grundlohnMitarbeitendeErhalten }}</td>
          </tr>

          <tr class="content">
            <th scope="row" colspan="1" class="border-bold-left border-bold-right">
              {{'i18n.cockpit.card.chart.gesamtverdienstLohn.zulagen' | translate }}
            </th>
            <td>{{ gesamtverdienstUndLohnbestandteile.zulagenMaennerDurchschnitt | numberFormat: crtLocale }}</td>
            <td>{{ gesamtverdienstUndLohnbestandteile.zulagenFrauenDurchschnitt | numberFormat: crtLocale }}</td>
            <td>{{ gesamtverdienstUndLohnbestandteile.zulagenDifferenz }}</td>
            <td class="border-bold-right">
              {{ gesamtverdienstUndLohnbestandteile.zulagenMitarbeitendeDurchschnitt | numberFormat: crtLocale }}</td>

            <td>{{ gesamtverdienstUndLohnbestandteile.zulagenMaennerAnteil }}</td>
            <td>{{ gesamtverdienstUndLohnbestandteile.zulagenFrauenAnteil }}</td>
            <td class="border-bold-right">{{ gesamtverdienstUndLohnbestandteile.zulagenMitarbeitendeAnteil }}</td>

            <td>{{ gesamtverdienstUndLohnbestandteile.zulagenMaennerErhalten }}</td>
            <td>{{ gesamtverdienstUndLohnbestandteile.zulagenFrauenErhalten }}</td>
            <td class="border-bold-right">{{ gesamtverdienstUndLohnbestandteile.zulagenMitarbeitendeErhalten }}</td>
          </tr>

          <tr class="content">
            <th scope="row" colspan="1" class="border-bold-left border-bold-right">
              {{ 'i18n.cockpit.card.chart.gesamtverdienstLohn.13-Monatslohn1-12' | translate }}
            </th>
            <td>{{ gesamtverdienstUndLohnbestandteile.monatslohn13MaennerDurchschnitt | numberFormat: crtLocale }}</td>
            <td>{{ gesamtverdienstUndLohnbestandteile.monatslohn13FrauenDurchschnitt | numberFormat: crtLocale }}</td>
            <td>{{ gesamtverdienstUndLohnbestandteile.monatslohn13Differenz }}</td>
            <td class="border-bold-right">
              {{ gesamtverdienstUndLohnbestandteile.monatslohn13MitarbeitendeDurchschnitt | numberFormat: crtLocale }}</td>

            <td>{{ gesamtverdienstUndLohnbestandteile.monatslohn13MaennerAnteil }}</td>
            <td>{{ gesamtverdienstUndLohnbestandteile.monatslohn13FrauenAnteil }}</td>
            <td class="border-bold-right">{{ gesamtverdienstUndLohnbestandteile.monatslohn13MitarbeitendeAnteil }}</td>

            <td>{{ gesamtverdienstUndLohnbestandteile.monatslohn13MaennerErhalten }}</td>
            <td>{{ gesamtverdienstUndLohnbestandteile.monatslohn13FrauenErhalten }}</td>
            <td class="border-bold-right">{{ gesamtverdienstUndLohnbestandteile.monatslohn13MitarbeitendeErhalten }}</td>
          </tr>

          <tr class="content">
            <th scope="row" colspan="1" class="border-bold-left border-bold-right">
              {{'i18n.cockpit.card.chart.gesamtverdienstLohn.sonderzahlungen' | translate }}
            </th>
            <td>{{ gesamtverdienstUndLohnbestandteile.sonderzahlungenMaennerDurchschnitt | numberFormat: crtLocale }}</td>
            <td>{{ gesamtverdienstUndLohnbestandteile.sonderzahlungenFrauenDurchschnitt | numberFormat: crtLocale }}</td>
            <td>{{ gesamtverdienstUndLohnbestandteile.sonderzahlungenDifferenz }}</td>
            <td class="border-bold-right">
              {{ gesamtverdienstUndLohnbestandteile.sonderzahlungenMitarbeitendeDurchschnitt | numberFormat: crtLocale }}</td>

            <td>{{ gesamtverdienstUndLohnbestandteile.sonderzahlungenMaennerAnteil }}</td>
            <td>{{ gesamtverdienstUndLohnbestandteile.sonderzahlungenFrauenAnteil }}</td>
            <td class="border-bold-right">{{ gesamtverdienstUndLohnbestandteile.sonderzahlungenMitarbeitendeAnteil }}</td>

            <td>{{ gesamtverdienstUndLohnbestandteile.sonderzahlungenMaennerErhalten }}</td>
            <td>{{ gesamtverdienstUndLohnbestandteile.sonderzahlungenFrauenErhalten }}</td>
            <td class="border-bold-right">{{ gesamtverdienstUndLohnbestandteile.sonderzahlungenMitarbeitendeErhalten }}</td>
          </tr>

          <tr class="content">
            <th scope="row" colspan="1" class="border-bold-left border-bold-right border-bold-top">{{'i18n.common.total' | translate}}</th>

            <td class="border-bold-top">{{ gesamtverdienstUndLohnbestandteile.totalMaennerDurchschnitt | numberFormat: crtLocale }}</td>
            <td class="border-bold-top">{{ gesamtverdienstUndLohnbestandteile.totalFrauenDurchschnitt | numberFormat: crtLocale }}</td>
            <td class="border-bold-top">{{ gesamtverdienstUndLohnbestandteile.totalDifferenz }} </td>
            <td class="border-bold-right border-bold-top">
              {{ gesamtverdienstUndLohnbestandteile.totalMitarbeitendeDurchschnitt | numberFormat: crtLocale }}</td>

            <td class="border-bold-top">{{ gesamtverdienstUndLohnbestandteile.totalMaennerAnteil }}</td>
            <td class="border-bold-top">{{ gesamtverdienstUndLohnbestandteile.totalFrauenAnteil }}</td>
            <td class="border-bold-right border-bold-top">{{ gesamtverdienstUndLohnbestandteile.totalMitarbeitendeAnteil }}</td>

            <td class="border-bold-top"></td>
            <td class="border-bold-top"></td>
            <td class="border-bold-right border-bold-top"></td>
          </tr>
          <tr class="hint">
            <td colspan="11" class="hint">{{'i18n.cockpit.card.hinveise-standarisierte-gehaelter' | translate}}</td>
          </tr>
        </table>
      </div>
    </div>

    <div class="pdt-20">
      <h5>{{ 'sprint9.cockpit.card.all.diagramm' | translate }}</h5>
      <h6>{{ 'sprint9.cockpit.card.all.ansichteinstellung' | translate }}</h6>

      <div style="display: flex; justify-content: start; flex-direction: row;">
        <div>
          <mat-button-toggle-group #btngroupAbsolutAnteil="matButtonToggleGroup" appearance="standard"
            id="btnTogglegroupAbsolutAnteil" name="btnTogglegroupAbsolutAnteil" [value]="absolut"
            aria-label="Absolut or Anteil">
            <mat-button-toggle value="{{absolut}}" (change)="selectionAbsolutAnteilChanged($event)">
              <small>{{ 'i18n.cockpit.card.chart.gesamtverdienstLohn.absolut' | translate}}</small></mat-button-toggle>

            <mat-button-toggle value="{{anteil}}" (change)="selectionAbsolutAnteilChanged($event)">
              <small>{{ 'i18n.cockpit.card.chart.gesamtverdienstLohn.anteil' | translate}}</small></mat-button-toggle>
          </mat-button-toggle-group>
        </div>

        <div class="diagram-margin">
          <mat-button-toggle-group #groupGestapeltUngestepelt="matButtonToggleGroup" appearance="standard"
            id="btnTogglegroupGestapeltUngestepelt" name="btnTogglegroupGestapeltUngestepelt" [value]="ungestapelt"
            aria-label="Ungestepelt or Gestapelt">
            <mat-button-toggle value="{{ungestapelt}}" (change)="selectionGestapeltUngestepeltChanged($event)">
              <small>{{ 'i18n.cockpit.card.chart.gesamtverdienstLohn.ungestapelt' | translate}}</small>
            </mat-button-toggle>
            <mat-button-toggle value="{{gestapelt}}" (change)="selectionGestapeltUngestepeltChanged($event)">
              <small>{{ 'i18n.cockpit.card.chart.gesamtverdienstLohn.gestapelt' | translate}}</small>
            </mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>

      <div id="svgContainerChartDialogGesamtverdienstLohnbestandteile" class="cockpit-svg-image"></div>
    </div>
  </div>
</div>
